import { getV1Config, setV1Config } from '@host-panel/request/config';

export const getLazyLoadMargin = async spotId => {
  try {
    const body = await getV1Config(spotId, ['lazy_load_margin']);
    return body?.lazy_load_margin;
  } catch (error) {
    console.log('error', error);
    return 0;
  }
};

export const updateLazyLoadValue = async (value, spotId) => {
  try {
    return await setV1Config(spotId, [{ key: 'lazy_load_margin', value: value }]);
  } catch (error) {
    console.log('error', error);
  }
};
